import type { AgChartLabelFormatterParams, RichFormatter, TextOrSegments, _ModuleSupport } from 'ag-charts-community';
import { isArray } from 'ag-charts-core';

import { formatWithContext } from '../../utils/formatter';

interface GaugeLabelDatum {
    value: number;
    text?: TextOrSegments;
    formatter?: RichFormatter<AgChartLabelFormatterParams<any>>;
}

interface Ctx {
    chartService: { context?: unknown };
}

export const fadeInFns: _ModuleSupport.FromToFns<_ModuleSupport.Node, any, any> = {
    fromFn: () => ({ opacity: 0, phase: 'initial' }),
    toFn: () => ({ opacity: 1 }),
};

export function formatLabel(value: number | undefined, scale: { min: number; max: number }) {
    if (value == null) return '';

    const { min, max } = scale;
    const minLog10 = min === 0 ? 0 : Math.ceil(Math.log10(Math.abs(min)));
    const maxLog10 = max === 0 ? 0 : Math.ceil(Math.log10(Math.abs(max)));
    const dp = Math.max(2 - Math.max(minLog10, maxLog10), 0);
    return value.toFixed(dp);
}

export function getLabelText(seriesId: string, ctx: Ctx, datum: GaugeLabelDatum, valueOverride?: number) {
    if (datum.text != null) return datum.text;

    const value = valueOverride ?? datum.value;
    let labelFormat: TextOrSegments | undefined;
    if (datum?.formatter != null) {
        labelFormat = formatWithContext(ctx, datum.formatter, { seriesId, datum: undefined, value });
    }
    return labelFormat == null || isArray(labelFormat) ? labelFormat : String(labelFormat);
}
